import type * as React from 'react';

/**
 * Available sizes for ScoreSticker.
 * - Lg: 128px with wrapper and optional indicator
 * - Sm: 63px with wrapper, no indicator
 * - Xs: 38px without wrapper, no indicator
 */
enum ScoreStickerSize {
  Lg = 'lg',
  Sm = 'sm',
  Xs = 'xs',
}

interface ScoreStickerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** The score value to display (0-100). */
  score: number | null;
  /**
   * The size of the sticker.
   * @default 'sm'
   */
  size?: ScoreStickerSize;
  /** Whether the component is in processing state (opacity 0.5). */
  isProcessing?: boolean;
  /** Whether the component is in loading state. */
  isLoading?: boolean;
  /** Score difference (positive = up, negative = down). Only shown for lg size. */
  scoreDiff?: number | null;
  /** Ref forwarded to the root element. */
  ref?: React.Ref<HTMLDivElement>;
}

export { ScoreStickerSize };
export type { ScoreStickerProps };
